var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M93.5345 18H32.4655C27.2378 18 23 22.4497 23 27.9387V92.0613C23 97.5503 27.2378 102 32.4655 102H93.5345C98.7622 102 103 97.5503 103 92.0613V27.9387C103 22.4497 98.7622 18 93.5345 18Z",
    fill: "#3695C1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.495 34C61.1356 39.6745 59.7125 43.3863 57.0856 48.8921C58.6962 50.5668 60.6732 52.5171 63.8838 54.7198C60.4321 53.3265 58.0776 51.9277 56.318 50.4761C52.9561 57.3577 47.6889 67.1602 37 86C45.4011 81.2423 51.9135 78.3091 57.9827 77.1899C57.7221 76.0904 57.5739 74.901 57.584 73.66L57.5939 73.396C57.7272 68.1162 60.5271 64.056 63.8438 64.3317C67.1606 64.6074 69.7387 69.1136 69.6054 74.3934C69.5803 75.3869 69.4661 76.3426 69.2665 77.229C75.2698 78.381 81.7126 81.3067 90 86C88.3659 83.0488 86.9073 80.3885 85.5144 77.8548C83.3203 76.1867 81.0318 74.0156 76.3637 71.6653C79.5723 72.4831 81.8696 73.4267 83.6603 74.4814C69.4983 48.6165 68.3515 45.1796 63.495 34Z",
    fill: "#F9F9F9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArch);
export default __webpack_public_path__ + "static/media/arch.82b33d5e40e2188e0550dcf0a32f8021.svg";
export { ForwardRef as ReactComponent };